import { parseApiError } from './parseApiError';

type ApiErrorDetail = { path?: string | Array<string | number>; message?: string };

// gloss
export const getApiErrorMessage = (errorData: unknown, fallback: string): string => {
  if (!errorData || typeof errorData !== 'object') {
    return fallback;
  }

  const details = (errorData as { details?: unknown }).details;
  if (Array.isArray(details)) {
    const detail = (details as ApiErrorDetail[]).find((d) => typeof d?.message === 'string' && d.message.trim());
    if (detail?.message) {
      const path = Array.isArray(detail.path) ? detail.path.join('.') : (detail.path ?? '');
      return path ? `${path}: ${detail.message}` : detail.message;
    }
  }

  const parsed = parseApiError(errorData);
  if (parsed.code !== 'UNKNOWN' && parsed.message.trim()) {
    return parsed.message;
  }

  return fallback;
};
